import { NgModule, ANALYZE_FOR_ENTRY_COMPONENTS, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { TableComponent } from './table.component';
import { TableCellHolderComponent, IBodyCell } from './cells/holders/body-cell.component';
import { ButtonComponent } from './cells/body/button/button.component';
import { TextArrayCellComponent } from './cells/body/text-array/text-array.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SearcherComponent } from '../components/searcher/searcher.component';
import { ComponentsModule } from '../components/components.module';
import { TextCellComponent } from './cells/body/text/text.component';
import { CheckboxCellComponent } from './cells/body/checkbox/checkbox.component';
import { SingleSelectionCellComponent } from './cells/body/selector/single/single.component';
import { MultiSelectionCellComponent } from './cells/body/selector/multi/multi.component';
import { TextHeaderCellComponent } from './cells/header/text/text.component';
import { TableHeaderCellHolderComponent, IHeaderCell } from './cells/holders/header-cell.component';
import { SelectorAllHeaderCellComponent } from './cells/header/selector/all/selector-all.component';
import { CellHolderDirective } from './cells/holders/cell-holder.directive';
import { DomHolderDirective } from './cells/holders/dom-holder.directive';
import { MenuHolderComponent } from './utility/context/abstract/menu/menu.component';
import { LocalMenuComponent } from './utility/context/local/menu/menu.component';
import { GlobalFilterComponent } from './utility/context/local/menu/global-filter/global-filter.component';
import { ColControlLocalComponent } from './utility/context/local/menu/col-control/col-control.component';
import { RemoteMenuComponent } from './utility/context/remote/menu/menu.component';
import { SelectorSingleComponent } from './cells/header/selector/single/selector-single.component';
import { ReseterComponent } from './utility/context/abstract/menu/reseter/reseter.component';
import { ColControlComponent } from './utility/context/abstract/menu/col-control/col-control.component';


@NgModule({ 
   imports: [
      CommonModule,
      FormsModule,
      BrowserAnimationsModule,
      ComponentsModule,
   ],
   declarations: [
      TableComponent,
      TableCellHolderComponent,
      TableHeaderCellHolderComponent,
      CellHolderDirective,
      DomHolderDirective,
      // ========= Cells =========
      TextCellComponent,
      ButtonComponent,
      TextArrayCellComponent,
      CheckboxCellComponent,
      LocalMenuComponent,
      GlobalFilterComponent,
      SingleSelectionCellComponent,
      MultiSelectionCellComponent,
      TextHeaderCellComponent,
      SelectorAllHeaderCellComponent,
      ColControlLocalComponent,
      MenuHolderComponent,
      RemoteMenuComponent,
      SelectorSingleComponent,
      ReseterComponent,
      ColControlComponent,
   ],
   exports: [
      TableComponent,
      TextCellComponent,
      ButtonComponent,
      TextArrayCellComponent,
      SearcherComponent,
   ],
   entryComponents: [
      TextCellComponent,
      ButtonComponent,
      TextArrayCellComponent,
      CheckboxCellComponent,
      SingleSelectionCellComponent,
      MultiSelectionCellComponent,
      TextHeaderCellComponent,
      SelectorAllHeaderCellComponent,
      SelectorSingleComponent,
      LocalMenuComponent,
      RemoteMenuComponent,
   ],
   providers: [],
})
export class TableModule {
   static withCustomCells(body: Type<IBodyCell<any>>[], header: Type<IHeaderCell>[] = []) {
      return {
         ngModule: TableModule,
         providers: [{
            provide: ANALYZE_FOR_ENTRY_COMPONENTS,
            useValue: [...body, ...header],
            multi: true
         }]
      };
   }
}
